import { render } from "./NBenefits.vue?vue&type=template&id=1f9b5dd8"
import script from "./NBenefits.vue?vue&type=script&lang=js"
export * from "./NBenefits.vue?vue&type=script&lang=js"

import "./NBenefits.vue?vue&type=style&index=0&id=1f9b5dd8&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__